import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = PropsWithChildren<{
  error?: boolean;
  className?: string;
}>;

export function FormHelpText({ children, className, error }: Props): JSX.Element {
  const classNames = twMerge('mt-1 text-xs', error ? 'text-red-500' : 'text-gray-500', className);

  return <small className={classNames}>{children}</small>;
}
